module.exports = __webpack_public_path__ + "static/pro1.png";